import React, { useEffect, useState } from 'react'

import { useLocation } from 'react-router-dom'

import { getOneApiAccess } from 'redux/api/Widgets'
import { TDashboardWidgetFullyLoaded } from 'types/GlobalWidget'

import PublicWidgetTemplate from 'components_new/templates/PublicWidgetTemplate'
import { useParams } from 'utils/hooks'
import { DashboardVariantType } from 'types/GlobalDashboard'

const ApiAccessWidgetPage = () => {
  const params = useParams<{ id: string }>()
  const id = params.id

  const [widget, setWidget] = useState<TDashboardWidgetFullyLoaded | null>(null)
  const [error, setError] = useState(false)
  const location = useLocation()

  const queryParams = new URLSearchParams(location.search)
  const token = queryParams.get('token') as string
  const loadingBGC = queryParams.get('loading-bgc') ?? undefined
  const companies = queryParams.get('companies')?.split(',') || []

  useEffect(() => {
    getOneApiAccess(id, token, { companies })
      .then((response) => setWidget(response.data.data))
      .catch(() => setError(true))
  }, [])

  return (
    <PublicWidgetTemplate
      error={error}
      loadingBGC={loadingBGC}
      widget={widget}
      variantType={DashboardVariantType.API}
    />
  )
}

export default ApiAccessWidgetPage
